import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { faBan, faFileDownload, faFileUpload, faPlus } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';
import { FarmsTableComponent } from '../farms-table/farms-table.component';

@Component({
  selector: 'kw-farms-list',
  templateUrl: './farms-list.component.html',
  styleUrls: ['./farms-list.component.scss']
})
export class FarmsListComponent implements OnInit {
  public loading: boolean = true;
  public faPlus = faPlus;
  public faBan = faBan;
  public faFileDownload = faFileDownload;
  public faFileUpload = faFileUpload;
  public gridName: string = "farmsConfigFilters";

  @ViewChild('farmsTable', { static: true }) farmsTable: FarmsTableComponent;

  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(
    public router: Router,
  ) { }

  ngOnInit() {
  }

  public onLoaded(){
    this.loading = false;
  }

  newFarmClicked() {
    if (this.farmsTable) {
      this.farmsTable.addFarmClicked(false, null);
    }
  }

  loadData() {
    if (this.farmsTable) {
      this.loading = true; // Start loading
      this.farmsTable.loadData().then(() => {
        this.loading = false; // End loading after data is loaded
      }).catch((error) => {
        this.loading = false; // Ensure loading is stopped on error
        console.error("Error loading data: ", error);
        
      });
    }
  }

  clearFilters() {
    if (this.farmsTable) {
      this.farmsTable.clearFilters();
    }
  }

    downloadTemplate(): void {
      const workbook = XLSX.utils.book_new();
      const templateData = [
        {
          'Name*': '',
          'Street Address': '',
          'City': '',
          'State': '',
          'Zip Code': '',
          'Email': '',
          'Default Tank Size': '',
          'Default Tank Size Unit': '',
          'Default Volume': '',  
          'Default Volume Unit': '',
          'Integration Id': '',
          'Customer Name': '',
          'Send Notifications': '',
        }];
  
      const worksheet = XLSX.utils.json_to_sheet(templateData, {
        header: Object.keys(templateData[0])
      });
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
      XLSX.writeFile(workbook, 'FarmsTemplate.xlsx');
    }

    onFileSelected(event: any){
      this.farmsTable.onFileSelected(event);
      this.fileInput.nativeElement.value = '';        // Reset file input
    }
    downloadFiles(args :string){
      this.farmsTable.downloadFiles(args);
    }
}
